import { cn } from "@/lib/cn";

interface OutsourceAccessLogoProps {
  className?: string;
  markClassName?: string;
  /** Render only the circular mark, without the wordmark. */
  markOnly?: boolean;
}

/**
 * Recreation of the Outsource Access mark (circular badge + upward chevron) as
 * crisp vector art, since no source logo file is available in the repo.
 */
export function OutsourceAccessLogo({ className, markClassName, markOnly }: OutsourceAccessLogoProps) {
  return (
    <div className={cn("flex items-center gap-2.5", className)}>
      <svg
        viewBox="0 0 40 40"
        className={cn("size-8 shrink-0", markClassName)}
        aria-hidden={!markOnly}
        role={markOnly ? "img" : undefined}
      >
        {markOnly && <title>Outsource Access</title>}
        <circle cx="20" cy="20" r="18" fill="hsl(var(--header-from))" stroke="white" strokeWidth="2.25" />
        <path
          d="M11.5 27 L19 12.5 Q20 11 21 12.5 L28.5 27"
          fill="none"
          stroke="hsl(var(--accent-cyan))"
          strokeWidth="3.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>

      {!markOnly && (
        <div className="min-w-0 leading-tight">
          <p className="truncate text-[13px] font-bold uppercase tracking-wide text-sidebar-foreground">
            Outsource Access<span className="align-super text-[8px]">™</span>
          </p>
          <p className="truncate text-[9px] font-semibold uppercase tracking-widest text-sidebar-muted">
            Redefining How You Scale
          </p>
        </div>
      )}
    </div>
  );
}
